<template>
  <!-- Page length options -->
  <div class="card">
    <div>
      <div
        v-show="onload"
        class="content bg-white"
      >
        <placeholder-content is-load="true" />
      </div>
      <div v-if="!onload && hasPermission">
        <access-denied />
      </div>
      <div
        v-show="!onload && !hasPermission"
        class="card-header bg-white header-elements-inline"
      >
        <h5 class="card-title">
          {{ $t("Shipping Charge Billing Report") }}
          <span>
            <a
              style="color:#706F72;"
              data-trigger="hover"
              data-popup="popover-suggestion"
              data-placement="left"
              :title="$t('Suggestion')"
              :data-content="$t('Summary of all shipping costs for shipment, search by generate tracking date. Consisting of shipping costs, COD fees, remote area fees, tourism area fees. Note: Actual shipping costs can be adjusted after the carrier imports your shipment into the carriers system.')"
            >
              <i class="fas fa-info-circle" />
            </a>
          </span>
        </h5>
      </div>
      <div
        v-show="!onload && !hasPermission"
      >
        <div v-show="!onload">
          <div class="d-flex align-items-center justify-content-start border-bottom mt-n3 mx-n3 flex-wrap pt-3 pl-3 pr-3">
            <!-- Date filter -->
            <div class="input-group flex-wrap w-100 pt-3 pb-3 px-3">
              <span class="col-form-label mr-3">{{ $t("Generate Tracking Date") }}</span>
              <div class="input-group w-auto">
                <span class="input-group-prepend">
                  <span class="input-group-text"><i class="fas fa-calendar-alt" /></span>
                </span>
                <date-range-picker
                  style="min-width: 175px"
                  opens="right"
                  :ranges="ranges"
                  v-model="dateRange"
                  :locale-data="localedata"
                  :control-container-class="'form-control rounded-left-0 rounded-right-0 border-right-0'"
                  @update="applyDatePicker"
                >
                  <div
                    slot="input"
                    v-html="showTextPicker"
                  />
                  <div
                    slot="footer"
                    slot-scope="data"
                    class="p-2 drp-buttons"
                  >
                    <button
                      @click="cancelDateRange()"
                      v-if="!data.in_selection"
                      type="button"
                      class="applyBtn btn btn-sm btn-secondary"
                    >
                      {{ $t("Cancel") }}
                    </button>
                    <button
                      @click="data.clickApply"
                      v-if="!data.in_selection"
                      type="button"
                      class="applyBtn btn btn-sm btn-primary"
                    >
                      {{ $t("Apply") }}
                    </button>
                  </div>
                </date-range-picker>
                <button
                  @click="openAdvanceFilter()"
                  type="button"
                  class="btn btn-outline-normal rounded-left-0 d-flex align-items-center"
                  data-toggle="modal"
                  data-target="#advance_filter"
                >
                  <i class="fas fa-sliders-v mr-2" />
                  <span>{{ $t("More Filters") }}</span>
                  <span
                    v-if="countFilter"
                    class="badge badge-secondary ml-2"
                  >{{ countFilter }}</span>
                </button>
                <span
                  v-if="showTotalFilter"
                  class="ml-2 text-blue-800"
                  style="padding-top: 8px;"
                >
                  {{ $t("Filters Results") }}:
                  {{ totalFilter | formatNumberNotZero }}
                </span>
              </div>
              <!-- Set PerPage -->
              <div class="d-flex align-items-center dataTables_length mb-0 ml-auto">
                <div class="dataTables_length ml-auto mb-0">
                  <PerPage @per-page="setPerPage" />
                </div>
              </div>
            </div>
            <!-- \Date filter -->
          </div>
        </div>

        <div
          v-show="!onload"
        >
          <div
            :class="['table-responsive mt-0 data-nowrap table-hover table-order']"
            id="table-order"
          >
            <div class="vuetable-wrapper datatable-scroll">
              <vuetable
                :class="[loadingTable, 'thead-bg-fafafa']"
                ref="vuetable"
                :no-data-template="$t('No Data Available')"
                :fields="table.fields"
                data-path="data"
                pagination-path=""
                :api-mode="false"
                :data-manager="dataManager"
                @vuetable:loaded="vuetableLoaded"
                @vuetable:loading="vuetableLoading"
                @vuetable:pagination-data="onPaginationData"
                @vuetable:initialized="onInitialized"
                :sort-order="sort"
              >
                <template
                  slot="topack_date"
                  slot-scope="props"
                >
                  <router-link
                    target="_blank"
                    :to="{ 
                      name: 'admin.reports.payments.shippingExpensesDetail', 
                      query: { 
                        topack_date: props.rowData.topack_date,
                        shipment_status: paramsQuery.shipment_status,
                        shipping_method_ids: paramsQuery.shipping_method_ids
                      }
                    }"
                  >
                    {{ props.rowData.topack_date }}
                  </router-link>
                </template>
                <template slot="tableFooter">
                  <tr style="background:#FAFAFA">
                    <th
                      v-for="(field, indexField) in dataFooterFields"
                      :class="field.dataClass"
                      :key="indexField + '_' + field.visible"
                    >
                      <template v-if="field.name == 'topack_date'">
                        {{ $t('Total') }}
                      </template>
                      <template v-if="field.name == 'count_shipment'">
                        {{ totalCountShipment }}
                      </template>
                      <template v-if="field.name == 'total_shipping'">
                        {{ totalShipping | formatNumber }}
                      </template>
                    </th>
                  </tr>
                </template>
              </vuetable>
            </div>
          </div>
          <div class="datatable-footer">
            <vuetable-pagination-info
              class="dataTables_info ml-3"
              ref="paginationInfo"
              :no-data-template="$t('No relevant data')"
              :info-template="$t('Displaying {from} to {to} of {total} items')"
            />
            <div class="dataTables_paginate paging_simple_numbers mb-0 mr-2">
              <vuetable-pagination
                ref="pagination"
                pagination-path="pagination"
                @vuetable-pagination:change-page="onChangePage"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <ShippingExpensesReportFilterMore 
      v-if="isadvanceFilter" 
      ref="advanceFilter"
      :shipment-status="shipmentStatus"
      :shipping-method="shippingMethod"
      @onSubmit="submitFilterMore"
    />
  </div>
</template>

<script>
import Api from "@/services/endpoint/tenant.service";
import ShippingExpensesReportFilterMore from './ShippingExpensesReportFilterMore';
import DateRangePicker from "vue2-daterange-picker";
import PerPage from "../PerPage.vue";
import Select2 from "v-select2-component";
import Vuetable from "vuetable-2";
import VuetablePagination from "vuetable-2/src/components/VuetablePagination";
import VuetablePaginationInfo from "@/plugins/vuetable-2/VuetablePaginationInfo";
import ShippingExpensesFields from "../assets/js/ShippingExpenses_fields.js";
import {
    showTextPicker,
} from "../assets/directives/Vuetable.js";
import moment from "moment";
import {
    convertTimezone
} from "@/common/tenancy/convertTimezone";
import numeral from "numeral";
import PlaceholderContent from "@/plugins/PlaceholderContent.vue";
import {
        tHeaderShipping,
        filterValShipping
} from '../assets/js/xlsx.js';
import AccessDenied from "@/components/tenancy/admin/error-page/templates/AccessDenied.vue";
export default {
    components: {
        ShippingExpensesReportFilterMore,
        DateRangePicker,
        PerPage,
        Select2,
        Vuetable,
        VuetablePagination,
        VuetablePaginationInfo,
        PlaceholderContent,
        AccessDenied
    },
    data() {
        return {
            checkedCount: 0,
            table: {
                fields: ShippingExpensesFields,
            },
            defaultStartDate: moment().subtract(1, 'months').format('YYYY-MM-DD 17:00:00'),
            defaultEndDate: moment().format('YYYY-MM-DD 16:59:59'),
            paramsQuery: {
                start: moment().subtract(1, 'months').format('YYYY-MM-DD 17:00:00'),
                end: moment().format('YYYY-MM-DD 16:59:59'),
                shipping_method_ids: [],
                shipment_status: undefined,
                limit: 10,
                page: 1,
                sort: 'topack_date|desc',
            },
            dateRange: {
                startDate: this.defaultStartDate,
                endDate: this.defaultEndDate,
            },
            amount:{
                countShipment: 0,
                totalShipping: 0,
            },
            vuetableFields: false,
            isadvanceFilter: false,
            countFilter: 0,
            totalFilter: 0,
            shipmentStatus: [],
            shippingMethod: [],
            showTotalFilter: false,
            dataFooterFields: [],
            dataTable: [],
            sort: [{
                field: 'topack_date',
                direction: 'desc'
            }],
            onload: true,
            hasPermission: true,
            ranges: this.$storeIndex.ranges(),
            localedata: {
                format: 'DD-MM-YYYY',
                applyLabel: this.$t('Apply'),
                cancelLabel: this.$t('Cancel'),
                clearable: true,
                monthNames: this.$storeIndex.monthNames(),
                daysOfWeek: this.$storeIndex.daysOfWeek(),
            },
            dateTxtFilter: null,
            loadingTable: null,
            i: 0,
            tHeaderShipping: null,
            filterValShipping: null,
            list: null,
            filename: '',
            autoWidth: true,
            bookType: 'xlsx',
            shipmentStatusSetting: {
                minimumResultsForSearch: Infinity,
                placeholder: this.$t("Shipping Status") + "..",
            },
        };
    },
    computed: {
        showTextPicker: function () {
            if (
                Object.keys(this.dateRange).includes("startDate") &&
                Object.keys(this.dateRange).includes("endDate") &&
                this.dateRange.startDate != null &&
                this.dateRange.endDate != null
            ) {
                this.dateRange.startDate = convertTimezone.utcToLocal(this.dateRange.startDate);
                this.dateRange.endDate = convertTimezone.utcToLocal(this.dateRange.endDate);
                this.dateTxtFilter = showTextPicker(this.dateRange);
                return this.dateTxtFilter;
            } else {
                return showTextPicker(this.paramsQuery);
            }
        },
        totalCountShipment() {
            let dataTable = this.dataTable.data;
            if (dataTable && dataTable.length > 0) {
                let totalCount = dataTable.map((item) => { return item.count_shipment });
                return totalCount.reduce((total, item) => total + item);
            }else {
                return 0
            }
        },
        totalShipping() {
            let dataTable = this.dataTable.data;
            if (dataTable && dataTable.length > 0) {
                let totalCount = dataTable.map((item) => { return parseFloat(item.total_shipping) });
                return totalCount.reduce((total, item) => total + item);
            }else {
                return 0
            }
        },
        footerTableFields() {
            if(this.vuetableFields !== false) {
                return this.$refs.vuetable.tableFields;
            }else {
                return [];
            }
        }
    },
    methods: {
        dataManager(sortOrder, pagination) {
            if (sortOrder.length > 0) {
                this.paramsQuery.sort = sortOrder.map((item) => `${item.sortField}|${item.direction}`).join(',')
            }
            this.setParams();
        },
        onPaginationData(tablePagination) {
            this.$refs.paginationInfo.setPaginationData(tablePagination);
            this.$refs.pagination.setPaginationData(tablePagination);
            // console.log(tablePagination,'tablePagination');
        },
        onInitialized(fields) {
            this.vuetableFields = fields.filter((field) => field.togglable);
        },
        onChangePage(page) {
            this.$refs.vuetable.changePage(page);
        },
        search() {
            this.setParams();
        },
        changeProductTypeEvent(val) {
            this.setParams();
        },
        setPerPage(perPage) {
            this.paramsQuery.page = 1;
            this.$refs.vuetable.currentPage = 1;
            this.paramsQuery.limit = perPage;
            this.setParams();
        },
        openAdvanceFilter() {
            this.isadvanceFilter = false;
            this.$nextTick(() => {
                this.isadvanceFilter = true
            });
        },
        vuetableLoaded() {
            // this.onload = false;
        },
        vuetableLoading() {},
        cancelDateRange() {
            this.paramsQuery.start = this.defaultStartDate;
            this.paramsQuery.end = this.defaultEndDate;
            $(".daterangepicker").remove();
            this.setParams();
        },
        applyDatePicker(dateRange) {
            let startDate = this.paramsQuery.start ? moment(dateRange.startDate).format('YYYY-MM-DD') : null;
            let endDate = this.paramsQuery.end ? moment(dateRange.endDate).format('YYYY-MM-DD') : null;
            var afterStartDate = startDate + ' 00:00:00';
            var afterEndDate = endDate + ' 23:59:59';
            this.paramsQuery.start = convertTimezone.localToUtc(afterStartDate);
            this.paramsQuery.end = convertTimezone.localToUtc(afterEndDate);
            this.setParams();
        },
        async setParams() {
            try {
                this.onload = true;
                this.paramsQuery.page = this.$refs.vuetable.currentPage;
                let queryString = "";
                if (this.paramsQuery) {
                    queryString += $.param(this.paramsQuery);
                }
                this.setQuerystring(this.paramsQuery);

                let result = [];

                result = await Api.ReportV2.getShippingChargeBilling(queryString);
                if (result.status != 200) {
                    this.onload = false;
                    if(result.status === 403 ){
                      if (result.data.message.indexOf("You can not active plan feature") != -1) {
                        this.planExpired = true;
                      } else {
                        this.hasPermission = true;
                      }
                    } else if (result.status === 500) {
                      this.hasPermission = true;
                    }
                }

                if (this.shipmentStatus.length == 0 && this.shippingMethod.length == 0) {
                    this.shipmentStatus = result.data.filter.shipment_status;
                    this.shippingMethod = result.data.filter.shipping_method;
                }
                this.dataTable = result.data;
                let data = this.$storeIndex.mutations.vueTableFormatJson(result);
                this.$refs.vuetable.setData(data);
                this.hasPermission = false;
                this.onload = false;
            } catch(error) {
                if (error.response.status == 403) {
                    this.hasPermission = true;
                    this.onload = false;
                } else {
                    this.$router.push({name: "t.a.home"});
                    console.log(error.response);
                }
            }

        },
        setQuerystring(obj) {
            this.$router.push({
                query: Object.assign({}, this.$route.query, obj)
            }).catch(() => {});
        },
        submitFilterMore(dataFilter) {
            console.log(`log:submitFilterMore-dataFilter`,dataFilter);
            this.paramsQuery.shipment_status = dataFilter.shipment_status
            this.paramsQuery.shipping_method_ids = dataFilter.shipping_method
            this.setParams()
        },
        changeShipmentStatusEvent(val) {
            this.setParams(1);
        },
        formatJson(filterValShipping, jsonData) {
            return jsonData.map(v => filterValShipping.map(j => {
                const jArr = j.split('.');
                if( jArr.length > 1){
                    return v[jArr[0]][[jArr[1]]];
                }

                if (j === 'timestamp') {
                    return parseTime(v[j])
                }else {
                    return v[j]
                }
            }))
        },
        convertTimezone(date) {
            return date != null && new Date(date) instanceof Date && !isNaN(new Date(date)) ? convertTimezone.utcToLocal(date) : '-';
        },
    },
    async mounted() {
        this.dateRange.startDate = this.paramsQuery.start = this.$route.query.start_date ? this.$route.query.start_date : this.defaultStartDate;
        this.dateRange.endDate = this.paramsQuery.end = this.$route.query.end_date ? this.$route.query.end_date : this.defaultEndDate;
        this.onload = true;
    },
    watch:{
      footerTableFields: {
          handler: function (nval, oval) {
              let newFooterTableArray = [];
              nval.forEach(element => {
                  if (element.visible === true) {
                      newFooterTableArray.push(element)
                  }
              });
              this.$nextTick(() => {
                  this.dataFooterFields = newFooterTableArray;
              });
          },
          deep: true
      },
      onload: function(nval) {
        _componentPopoverCustomHeaderColor();
      }
    },
    filters: {
        formatNumber: function (value) {
            return numeral(value).format("0,0.00");
        },
        formatNumberDigit: function (value){
          return numeral(value).format("0,0");
        },
    },
    created() {
        this.tHeaderShipping = tHeaderShipping()
        this.filterValShipping = filterValShipping()
    },
};
var _componentPopoverCustomHeaderColor = function() {
  $('[data-popup=popover-suggestion]').popover({
    template: '<div class="popover border-light"><div class="arrow"></div><p class="popover-header bg-light font-weight-bold"></p><div class="popover-body"></div></div>'
  });
};
</script>

<style scoped>
.input-group>.input-group-prepend:not(:first-child)>.input-group-text {
    border-top-left-radius: 0.1875rem;
    border-bottom-left-radius: 0.1875rem;
}
.popover {
    font-family: 'Sarabun', sans-serif;
    max-width: 500px;
  }
</style>



// WEBPACK FOOTER //
// src/components/tenancy/admin/report/finance/ShippingExpensesReport.vue